export interface CustomerStatus {
  label: string
  value: string
}

export const customerStatusType: CustomerStatus[] = [
  {
    label: 'Todos',
    value: '',
  },
  {
    label: 'Com saldo',
    value: 'HAS_AMOUNT',
  },
  {
    label: 'Não autorizado',
    value: 'UNAUTHORIZED',
  },
]
